// extracted by mini-css-extract-plugin
export default {"video":"SolutionCell__video___jbJd5","indicator":"SolutionCell__indicator___Uu_z8"};